module.exports = __webpack_public_path__ + "static/media/egg.a7446f2c.png";